import { createFileRoute } from "@tanstack/react-router";
import CultivationFetch from "../../app/views/cultivation/cultivationFetch";

const CultivationFetchComponent = () => (
  <CultivationFetch cultivationType="odling" />
);

export const Route = createFileRoute("/cultivation/fetch")({
  component: CultivationFetchComponent,
});
